import { produce } from 'immer'
import { profileDeleteRouteProps } from 'src/navigation/routeProps'
import {
  DELETE_USER_FAILURE,
  DELETE_USER_INIT,
  DELETE_USER_SUCCESS,
  DeleteUserActions,
} from 'src/redux/actions/data/users.actions'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'

export interface ProfileDeleteState {
  deletingUser: boolean
  topLevelError?: string
  errorDetailMap?: ErrorDetailMap<string>
}

export const initialState: ProfileDeleteState = {
  deletingUser: false,
}

export type Actions = DeleteUserActions

const CoreProfileDeleteReducer = (
  state = initialState,
  action: Actions,
): ProfileDeleteState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case DELETE_USER_INIT: {
        draft.deletingUser = true
        draft.topLevelError = undefined
        draft.errorDetailMap = undefined
        return draft
      }

      case DELETE_USER_SUCCESS: {
        draft.deletingUser = false
        return draft
      }

      case DELETE_USER_FAILURE: {
        draft.deletingUser = false
        const errors = parseBackendErrors(action.payload)
        draft.topLevelError = errors.topLevelError
        draft.errorDetailMap = errors.errorDetailMap
        return draft
      }
    }
  })
}

const ProfileDeleteReducer = createBackgroundReducer(
  profileDeleteRouteProps,
  initialState,
  CoreProfileDeleteReducer,
)

export default ProfileDeleteReducer
